module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/8-58fa53d58e331c06fe5b2eac91086e90.svg";